import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { selectActivityOrg } from "../../../../../actions";
import AccessDeniedPanel from "../SuperUserPanel/AccessDenied";
import OrgList from "./OrgList";

const Index = ({
  superUser,
  orgDevices,
  organizations,
  organizationId,
  selectActivityOrg,
}) => {
  const [orgs, setOrgs] = useState([]);

  useEffect(() => {
    setOrgs(
      Object.entries(orgDevices)
        .map(([org, tools]) => ({
          org,
          // the backend's env-narrowed tally when it sent one; the raw tools
          // length is the pre-deploy fallback
          devices: organizations[org]?.deviceCount ?? (tools || []).length,
          unreadMaintenanceCount:
            organizations[org]?.unreadMaintenanceCount || 0,
        }))
        .sort((a, b) => {
          if (a.org < b.org) {
            return -1;
          }
          if (a.org > b.org) {
            return 1;
          }
          return 0;
        })
    );
  }, [orgDevices, organizations]);

  return superUser ? (
    <OrgList
      orgs={orgs}
      selectedOrg={organizationId}
      onSelectOrg={selectActivityOrg}
    />
  ) : (
    <AccessDeniedPanel />
  );
};

export const mapStateToProps = (state) => {
  const superUser = state?.user?.superUser || false;
  const orgDevices = state?.user?.orgDevices || {};
  const organizations = state?.user?.organizations || {};
  const organizationId = state?.activityMonitor?.organizationId ?? null;
  return {
    superUser,
    orgDevices,
    organizations,
    organizationId,
  };
};

export default connect(mapStateToProps, {
  selectActivityOrg,
})(Index);
